import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
`;

interface TimerDivProps {
    type?: 'warning' | 'error';
}

export const TimerDiv = styled.div<TimerDivProps>`
    width: 100%;
    background-color: ${({ type }) =>
        type === 'warning' ? '#FFD700' :
        type === 'error'? '#FF6347' :
        '#32BCAD'
    };
    color: #FFF;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.36px;
    padding: 12px;
    border-radius: 12px;
`;

export const QrCode = styled.img`
    width: 178px;
    height: 178px;
    border-radius: 8px;
    border: 2px solid #000;
`;

export const Info = styled.div`
    width: 100%;
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.36px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
`;